import React, { useCallback, useEffect, useState, useRef } from "react";
import { injectIntl, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
// Actions
import {
} from "Redux/actions";
// Components
import { Grid, Grow, Container, Icon, Typography } from "@mui/material";
import { Button } from 'Components/uiControls';
// import EntityTagPicker from 'Modules/.common/components/TagPickerFilter';
import TagsManage from "Modules/.common/components/TagsManage";

import './styles.scss';
import { endpoints } from 'Core/defaultValues';

//requires permission XML 10
const DataExportTab = (props) => {
  // Props
  const { messages } = useIntl();

  const [formData, setFormData] = useState({ units: [] });
  const [url, setUrl] = useState('');
  const user = useSelector(state => state.securityRedux.user);
  const urlDate = new Date().toISOString().slice(0, 10)


  // Hooks


  return (
    <Container className="dataExport-Contain1000" maxWidth={false} >
      <Grid container style={{ height: '100%' }} direction="column" justifyContent="space-between" alignItems="flex-start">
        <Grid item >
          <h2 style={{ margin: 0 }}>{messages['dataExport_xmlOutputLabel']}</h2>
          <div style={{ marginTop: 10, width: "400px", maxWidth: "400px" }}>
            {/* <EntityTagPicker
              entity="Unit"
              height={250}
              value={formData?.units || []}
              showUntagged={true}
              disableTagSelection={false}
              disableUntaggedSelection={false}
              onlyValueId={false}
              multiple={false}
              showSelectedItemsBelow={true}
              onChange={(newUnits) => {
                setUrl('')
                setFormData({ ...formData, units: newUnits });
              }}
            /> */}
            <TagsManage
              entities={[
                { id: "Unit", label: "Unit" }
              ]}
              entitySelected={{ id: "Unit", label: "Unit" }}
              height={250}
              mode='list'
              value={formData?.units || []}
              showUntagged={true}
              disableTagSelection={false}
              disableUntaggedSelection={false}
              onlyValueId={false}
              multiple={false}
              onChange={(newUnits) => {
                setUrl('')
                setFormData({ ...formData, units: newUnits });
              }}
            />
          </div>
          <Button
            id="btnGetUrl"
            className="btn btn-blue btn-block"
            disabled={formData?.units?.length ? false : true}
            onClick={(e) => {
              e.preventDefault();
              setUrl(user.accountDataPump + "/" + formData.units[0].name + "/" + formData.units[0].id);
            }}
          >{messages['dataExport_url']}</Button>
        </Grid>
        {
          url &&
          <Grid item >
            <p className="description">{messages['dataExport_dataPumpFeedDescription']}</p>
            <a className="dataPumpUrl" type="link" target={"_blank"}
              href={endpoints.DATAEXPORT_URL + "dataPump/datapump_feed/" + url + "/" + urlDate + "/" + urlDate} >
              {messages['dataExport_dataPumpFeedLabel']}
            </a>
            <p className="description">{messages['dataExport_dataFeed1Description']}</p>
            <a className="dataPumpUrl" type="link" target={"_blank"}
              href={endpoints.DATAEXPORT_URL + "dataPump/feed1/" + url} >
              {messages['dataExport_dataFeed1Label']}
            </a>
            <p className="description">{messages['dataExport_dataFeed2Description']}</p>
            <a className="dataPumpUrl" type="link" target={"_blank"}
              href={endpoints.DATAEXPORT_URL + "dataPump/feed2/" + url} rel="noreferrer">
              {messages['dataExport_dataFeed2Label']}
            </a>
            <p className="description">{messages['dataExport_dataFeed3Description']}</p>
            <a className="dataPumpUrl" type="link" target={"_blank"}
              href={endpoints.DATAEXPORT_URL + "dataPump/feed3/" + url} rel="noreferrer">
              {messages['dataExport_dataFeed3Label']}
            </a>


          </Grid>

        }

        <Grid item className="dataExport-footer">{messages['dataExport_FooterLabel']}</Grid>

      </Grid>


    </Container>

  );
}

export default injectIntl(DataExportTab);